import useAppModal from 'hooks/useAppModal';
import { Integration } from 'models/InternalIntegrationSetting';
import EnableHostfullyDeviceModal from './EnableHostfullyDeviceModal';

const ENABLE_HOSTFULLY_DEVICES_MODAL_ID = 'enable-hostfully-devices-modal';

const useEnableHostfullyDeviceModal = () => {
  const { openModal } = useAppModal();

  const openEnableHostfullyDeviceModal = ({
    integration,
    onConfirm,
  }: {
    integration: Integration;
    onConfirm: () => void;
  }) => {
    openModal({
      customContent: (
        <EnableHostfullyDeviceModal
          integration={integration}
          onConfirm={onConfirm}
          modalId={ENABLE_HOSTFULLY_DEVICES_MODAL_ID}
        />
      ),
      id: ENABLE_HOSTFULLY_DEVICES_MODAL_ID,
      size: 'medium',
    });
  };

  return { openEnableHostfullyDeviceModal };
};

export default useEnableHostfullyDeviceModal;
